import { assertNever } from "helpers/Helpers";
import React from "react";
import { ActionButton } from "components/generic/ActionButton";
import { BookingStatus } from "generated/types/types";
import { useTranslation } from "react-i18next";

type Properties = {
    bookingStatus: BookingStatus;
    onCancel: () => void;
    onCancelRerequest: () => void;
    onRequestNewBooking: () => void;
    onAcceptOfferedDate: () => void;
};

export const BookingActions: React.FC<Properties> = props => {
    const { t } = useTranslation();
    const buttons: React.ReactNode[] = [];
    switch (props.bookingStatus) {
        case BookingStatus.AlternativeDateOffered:
            buttons.push(<ActionButton key="AcceptDateOffered" label={t("booking_actions_accept")} onClick={() => props.onAcceptOfferedDate()} />);
            buttons.push(<ActionButton key="CancelAndReRequest" label={t("booking_actions_cancel_rerequest")} onClick={() => props.onCancelRerequest()} />);
            buttons.push(
                <p key="Cancel" className="link-muted" onClick={() => props.onCancel()}>
                    {t("booking_actions_cancel")}
                </p>
            );
            break;
        case BookingStatus.Confirmed:
            buttons.push(<ActionButton key="CancelAndReRequest" label={t("booking_actions_cancel_rerequest")} onClick={() => props.onCancelRerequest()} />);
            buttons.push(
                <p key="Cancel" className="link-muted" onClick={() => props.onCancel()}>
                    {t("booking_actions_cancel")}
                </p>
            );
            break;
        case BookingStatus.Declined:
            buttons.push(<ActionButton key="CancelAndReRequest" label={t("booking_actions_rerequest")} onClick={() => props.onCancelRerequest()} />);
            buttons.push(
                <p key="Cancel" className="link-muted" onClick={() => props.onCancel()}>
                    {t("booking_actions_cancel")}
                </p>
            );
            break;
        case BookingStatus.Received:
            break;
        case BookingStatus.Cancelled:
        case BookingStatus.Expired:
            buttons.push(<ActionButton key="requestNewBooking" label={t("booking_actions_request")} onClick={() => props.onRequestNewBooking()} />);
            break;
        default:
            assertNever(props.bookingStatus);
    }

    return <div className="row section">{buttons}</div>;
};
